import { useEffect, useState } from 'react'

export function usePreviewUrl(source: File | string | null | undefined) {
  const [url, setUrl] = useState<string | null>(null)

  useEffect(() => {
    if (!source) {
      setUrl(null)
      return
    }

    if (typeof source === 'string') {
      setUrl(source)
      return
    }

    const objectUrl = URL.createObjectURL(source)
    setUrl(objectUrl)

    return () => URL.revokeObjectURL(objectUrl)
  }, [source])

  return url
}

export const useProductPhotoPreviewUrl = usePreviewUrl
